module.exports = __webpack_public_path__ + "img/bigfive_c3.38e672dc.png";